/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Timeline_LogInputs */

const en_dashboard_timeline_log = /** @type {(inputs: Dashboard_Timeline_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timeline Log`)
};

const pt_br2_dashboard_timeline_log = /** @type {(inputs: Dashboard_Timeline_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Histórico`)
};

/**
* | output |
* | --- |
* | "Timeline Log" |
*
* @param {Dashboard_Timeline_LogInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const dashboard_timeline_log = /** @type {((inputs?: Dashboard_Timeline_LogInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Timeline_LogInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_timeline_log(inputs)
	return pt_br2_dashboard_timeline_log(inputs)
});